import axios from "axios";

export const config = {
  appUrl: "/",
}

export const axiosInstance = axios.create({
  baseURL: "https://earth.cubextechnology.com/api/",
  // baseURL: "http://localhost/maa-admin/api/",

  headers: {
    "Content-Type": "application/json",
    'Access-Control-Allow-Origin': '*'
  },
});

